import { AUTHORING_CELL, FOOT_HALF_WIDTH, FOOT_HEIGHT } from "../movement/step.ts";

/**
 * Who stands under a roof, out of the rain (ADR-144's amendment of 2026-11-01, decision 3): the one test the map server
 * runs over its compiled sight planes' rooms and the page runs over the room plane it builds from the roof areas it
 * draws (`roomPlaneOf`, the compile's own rule), so the two agree on every cell, overlaps and roofs past the 255th
 * included.
 */

/**
 * Whether any cell of a character's feet box lies in a room.
 *
 * @param rooms The room plane, one byte an authoring cell, row-major; undefined for a map with no roof.
 * @param width The plane's width in authoring cells.
 * @param height The plane's height in authoring cells.
 * @param x The feet x in sixteenths.
 * @param y The feet line in sixteenths.
 * @returns True under a roof.
 */
export function roofedAt(rooms: Uint8Array | undefined, width: number, height: number, x: number, y: number): boolean {
  if (rooms === undefined) {
    return false;
  }
  const left = Math.max(0, Math.floor((x - FOOT_HALF_WIDTH) / AUTHORING_CELL));
  const right = Math.min(width - 1, Math.floor((x + FOOT_HALF_WIDTH - 1) / AUTHORING_CELL));
  const top = Math.max(0, Math.floor((y - FOOT_HEIGHT) / AUTHORING_CELL));
  const bottom = Math.min(height - 1, Math.floor((y - 1) / AUTHORING_CELL));
  for (let row = top; row <= bottom; row += 1) {
    for (let column = left; column <= right; column += 1) {
      if (rooms[row * width + column] !== 0) {
        return true;
      }
    }
  }
  return false;
}
